<template>
  <div class="about3">
    <div>
      <strong>文衡聖帝</strong>
    </div>
    <div>&nbsp;</div>
    <div>
      文衡聖帝又稱關聖帝君，關聖帝君是我國歷史上記載的真實人物，亦即三國時代的猛將關羽，由於他高尚的五常品格－－仁、義、禮、智、信，和忠義之氣，被士民敬為神。
      關聖帝君生前的事蹟忠貫日月，義炳千秋，原為中國人所景仰，明清以降，儒佛道三教，更與帝君攀上關係；儒教尊之為「文衡」，佛教中尊關聖帝君為「蓋天佛陀」、「護法伽藍」，道教則尊聖帝為「翊漢天尊」、「協天大帝」、「崇富尊君」、「三界伏魔大帝」，又稱恩主公。
    </div>
    <div>&nbsp;</div>
    <div>
      明、清兩朝，更將關聖帝君列為國家供奉，與孔子並列為聖，孔子為文聖，帝君為武聖。關公生前勇猛善戰，因此軍人奉之戰神，過去軍中也常流傳關公顯聖殺敵的故事；另各地的國術館也一定供奉關公，並在館門口插一把大關刀作為標記，亦即表示崇尚武德之意。
    </div>
    <div>&nbsp;</div>
    <div>
      另有人將關公奉為商人的保護神，傳說關公從軍之前，原在山西老家賣布為生，由於關公出身商賈，因之商人將之奉為神。
    </div>
    <div>&nbsp;</div>
    <div>
      <strong>山西祖廟關聖帝君</strong>
    </div>
    <div>&nbsp;</div>
    <div>
      西元2007至2009年山西運城解州祖廟《關聖帝君》奉旨聖駕分靈蒞台環島巡禮，為時三年並駐駕全台32間宮廟，供信徒參拜；2013年10月奉玉旨鎮守本殿，以保佑全台。
    </div>
    <div>&nbsp;</div>
    <div>
      西元2013年，解州祖廟再指派具有500多年歷史的明朝關聖帝君聖駕跨海抵台巡禮祈福，本殿祖上帝君奉旨為護台主官，展開為期21天全台繞境祈福活動，保佑台灣風調雨順、國泰民安、消災解厄、共沐神恩。活動圓滿結束，本殿祖上帝君蒙玉皇上帝敕旨加封【護台恩廣帝君】並請靈霄寶殿張天師爺御筆提賜九龍匾，暨五位帝君並奉旨鎮守龍崎文衡殿護台及庇護眾生；另天南主宰御竹宮的星君特賜本殿赤兔寶馬可至玉竹宮自由取食。
    </div>
    <div>&nbsp;</div>
    <div>
      經帝君聖示：帝君聖誕之日暨過年期間，特許開啟鑽神桌祈福，藉由鑽神桌之儀式，與帝君近距離的接觸，來受到神恩保佑身體健康、事業順利，運涂光明、消災納福。
    </div>
  </div>
</template>

<script>
export default {
  name: 'About3',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped></style>
